const loadingLabel = "Se încarcă";
const roRO = {
  loadingLabel
};
export {
  roRO as default,
  loadingLabel
};
